<template>
  <div v-show="show" class="record-dubbing">
    <div v-show="!recordError" class="record-play-box">
      <div class="mask-content">
        <div class="mask-top" :style="maskTopStyle"></div>
        <div class="mask-left" :style="maskLeftStyle"></div>
        <div class="mask-right" :style="maskRightStyle"></div>
        <div class="mask-bottom" :style="maskBottomStyle"></div>
      </div>
      <div
        class="record-close-button"
        @click="close"
        :style="closeStyle"
      >
        <i></i>
      </div>
      <div class="record-preview" :style="recordPreviewStyle">
        <div class="record-timeline">
          <div class="record-timeline-box">
            <div class="rc-slider" :style="{width: playTime/totalTime*100+'%'}"></div>
            <div
              v-drag
              class="rc-slider-handle"
              :style="{left: `calc(${playTime/totalTime*100}% - 6px)`}"
            ></div>
          </div>
        </div>
        <div class="record-button">
          <div v-show="recordStatus === 'before'" class="record-before">
            <div @click="recordStart()"></div>
            <p>点击开始录音</p>
          </div>
          <div v-show="recordStatus === 'ready'" class="record-ready">
            <div>{{readyInfo}}</div>
            <p>开始准备录音</p>
          </div>
          <div v-show="recordStatus === 'ing'" class="record-ing">
            <div class="ing-left">
              <div></div>
              <p>正在录音中...</p>
            </div>
            <p></p>
            <div class="ing-right">
              <div class="ing-time">
                <span>{{recordTime | secToMin}}</span>
                <span>(最长可录制{{maxTime | secToMin}})</span>
              </div>
              <el-button type="primary" class="ing-button" @click="cancelPlay()">结束录音</el-button>
            </div>
          </div>
          <div v-show="recordStatus === 'complete'" class="record-complete">
            <div class="complete-left">
              <div v-show="playStatus !== 'stop'" class="stop">
                <div @click="playSound('stop')"></div>
                <p>停止</p>
              </div>
              <div v-show="playStatus !== 'start'" class="start">
                <div @click="playSound(playStatus === 'pause'? 'continue' : 'start')"></div>
                <p>{{playStatus === 'pause'? '继续试听' : '试听'}}</p>
              </div>
              <div v-show="playStatus === 'start'" class="pause">
                <div @click="playSound('pause')"></div>
                <p>暂停</p>
              </div>
            </div>
            <p></p>
            <div class="complete-right">
              <span>{{(playTime - startTime) | secToMin}}/{{soundTime | secToMin}}</span>
              <div class="complete-button">
                <el-button type="primary" @click="saveRecord()">录好了</el-button>
                <el-button @click="reRecord()">重新录</el-button>
              </div>
            </div>
          </div>
          <div class="time-show-box">
            {{playTime|secToMin}}/{{totalTime|secToMin}}
          </div>
        </div>
      </div>
      <div v-show="showTip" class="record-drag-tip" :style="dragTipStyle">
        拖动至需要插入录音的时间点，点击录音按钮开始录音。
      </div>
    </div>
    <div v-if="showSave" class="save-box">
      <SaveRecord
        @close="closeSave"
        @saveUpload="saveUpload"
        @cancelUpload="cancelUpload"
      />
    </div>
    <div v-show="recordError" class="record-error">
      <div class="record-error-box">
        <div class="title">
          <span>录音设备异常提示</span>
          <div class="close-button" @click="close">
            <i></i>
          </div>
        </div>
        <div class="content">
          <div>
            检测到您当前的麦克风设备异常,无法进行录音.还请调试好录音设备后重试.
          </div>
          <div>
            以下可能引发异常情况供您参考:
          </div>
          <div>{{errorInfo}}</div>
        </div>
        <div class="button-content">
          <el-button type="primary" @click="close">知道了</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import SaveRecord from "./saveRecord";

export default {
  name: 'RecordDubbing',
  components: {
    SaveRecord
  },
  data() {
    return {
      show: false,              // 是否显示
      playTime: 0,              // 播放时间，用于进度条的显示
      startTime: 0,             // 播放开始的时间
      endTime: 0,               // 录音结束后可以播放的末尾时间
      totalTime: 10,            // 总时长
      timeNode: [0],            // 每个scenes的时间节点数组
      maxTime: 0,               // 最长可录制的时间（ms)
      recordStatus: 'before',   // 录音的状态
      playStatus: 'stop',       // 播放的状态
      audioChunks: [],          // 录音后的数据数组
      readyInfo: 3,             // 准备录音的倒计时显示
      recorder: null,           // 录音的操作对象
      audio: null,              // 录音之后的播放dom
      breakAll: false,          // 关闭录音
      recordTime: 0,            // 当前录音时间的显示
      soundTime: 0,             // 录音的总时间
      secondWidth: 100,         // 每一秒的宽度
      mpos: {                   // 拖动临时数据
        x: 0,
        playTime: 0
      },
      animFrame: null,
      showSave: false,
      closeUpload: false,
      recordError: false,
      errorInfo: '请确保支持录音',
      showTip: true
    }
  },
  computed: {
    ...mapGetters([
      "SetPanel_Size",
      "MaterialPane_Size",
      "TopNav_Size",
      "Tool_Size",
      "Window_Size",
      "TOOL"
    ]),
    ...mapGetters({
      subtitleObj: "subtitle/subtitleObj",
    }),
    editorStyle() {
      if (!this.subtitleObj) return;
      let style = {
        position: "relative",
      };
      let left = 0;
      let top = 0;
      let width = 0;
      let height = 0;
      if (this.subtitleObj.type === "draft") {
        width = this.TOOL.clientWidth;
        height = this.TOOL.clientHeight;
        top = this.TOOL.fixTop + 40;
        // left = this.TOOL.fixLeft + 246;
        // left = 388;
        left = this.MaterialPane_Size.width + this.TOOL.fixLeft;
      } else {
        var maxSize = 0,
          multiple = 0.9;
        if (this.containerSize.width > (this.containerSize.height * 16) / 9) {
          maxSize = ((this.containerSize.height * multiple) / 9) * 16;
        } else {
          maxSize = this.containerSize.width * multiple;
        }
        width = maxSize;
        height = (maxSize / 16) * 9;
        left = (this.containerSize.width - width) / 2;
        top = (this.containerSize.height - height) / 2 + 15;
      }
      if (this.subtitleEditor) {
        this.subtitleEditor.setOption({
          width: width,
          height: height,
          rootId: "subtitleEditor-container",
        });
      }
      // this.editorOffset.top = top;
      // this.editorOffset.left = left;
      style.width = width + "px";
      style.height = height + "px";
      style.top = top + "px";
      style.left = left + "px";
      // this.canvasSize.width = width;
      // this.canvasSize.height = height;
      return style;
    },
    maskTopStyle() {
      const style = {};
      style.height = this.TOOL.fixTop + this.TopNav_Size.height + 40 + "px";
      style.top = 0;
      style.left = 0;
      return style;
    },
    maskLeftStyle() {
      const style = {};
      style.width = this.TOOL.fixLeft + 246 + "px";
      style.height = this.Tool_Size.height - this.TOOL.fixTop * 2 - 40 + "px";
      style.top = this.TOOL.fixTop + this.TopNav_Size.height + 40 + "px";
      style.left = 0;
      if (this.editorStyle) {
        style.width = this.editorStyle.left;
      }
      return style;
    },
    maskRightStyle() {
      let gap = document.body.clientWidth - (this.TOOL.clientWidth + 246 + this.TOOL.fixLeft + this.SetPanel_Size.width)
      const style = {};
      style.width = gap + this.SetPanel_Size.width + "px";
      style.height = this.Tool_Size.height - this.TOOL.fixTop * 2 - 40 + "px";
      style.top = this.TOOL.fixTop + this.TopNav_Size.height + 40 + "px";
      style.right = 0;
      if (this.editorStyle) {
        const l = parseFloat(this.editorStyle.left);
        const w = parseFloat(this.editorStyle.width);
        style.width = document.documentElement.offsetWidth + 1 - l - w;
        style.width += 'px';
      }
      return style;
    },
    maskBottomStyle() {
      const style = {};
      style.height =
        this.Window_Size.height +
        this.TOOL.fixTop -
        this.TopNav_Size.height -
        this.Tool_Size.height +
        "px";
      style.top =
        this.TopNav_Size.height +
        this.Tool_Size.height -
        this.TOOL.fixTop +
        "px";
      style.right = 0;
      return style;
    },
    recordPreviewStyle() {
      const style = {};
      style.width = this.TOOL.clientWidth + "px";
      style.left = this.TOOL.fixLeft + 246 + "px";
      style.top =
        this.TOOL.fixTop +
        this.TopNav_Size.height +
        40 +
        this.TOOL.clientHeight +
        "px";
      if (this.editorStyle) {
        style.width = this.editorStyle.width;
        style.left = this.editorStyle.left;
      }
      return style;
    },
    dragTipStyle() {
      const style = {};
      style.top =
        this.TOOL.fixTop +
        this.TopNav_Size.height -
        28 +
        this.TOOL.clientHeight +
        "px";
      style.left = this.TOOL.fixLeft + 17 + 246 + "px";
      return style;
    },
    closeStyle() {
      const style = {};
      style.left = this.TOOL.clientWidth + this.TOOL.fixLeft + 246 + "px";
      style.top = this.TOOL.fixTop + this.TopNav_Size.height + 30 + "px";
      if (this.editorStyle) {
        const l = parseFloat(this.editorStyle.left);
        const w = parseFloat(this.editorStyle.width);
        style.left = (l + w) + 'px';
      }
      return style;
    },
  },
  mounted() {
    this.initData();

    this.$bus.on('open-record-preview', data => {
      this.show = true;
      if(data.error) {
        this.recordError = true;
        if(data.error === 'NotAllowedError') {
          this.errorInfo = '您的浏览器未开启录音，无法支持录音。';
        } else if(data.error === 'noFunction') {
          this.errorInfo = '当前浏览器不支持录音，我们建议您下载最新版的谷歌浏览器以更好地支持录音。'
        } else if(data.error === 'NotFoundError') {
          this.errorInfo = '您未连接麦克风设备，无法支持录音。';
        }
        return;
      }
      if(!localStorage.getItem('recordOpenForTip')){
        localStorage.setItem('recordOpenForTip', true);
        this.showTip = true;
      }else {
        this.showTip = false;
      }
      this.$store.commit("subtitle/toggle_isPreventDefault", false);
      this.startTime = data.start || 0;
      this.resetData();
    })
  },
  beforeDestroy() {
    this.$bus.off('open-record-preview');
  },
  methods: {
    initData() {
      this.audio = document.createElement('audio');

      this.getTimeNode();
      this.secondWidth = (this.TOOL.clientWidth - 12) / this.totalTime;
    },
    getTimeNode() {
      let totalTime = 0;
      // 获取每个scenes组的开始和结束时间，并将scenes初始到第0帧
      if (this.TOOL && this.TOOL.sprites) {
        for (let i = 0; i < this.TOOL.sprites.length; i++) {
          let scene = this.TOOL.sprites[i];
          this.TOOL.eve.emit("playByFrame", 0, scene.id);
          this.TOOL.eve.emit("play_" + scene.id, 0);
          this.TOOL.player.scenesDict[scene.id].ele.hide();
          totalTime += scene.duration / 1000;
          this.timeNode[i + 1] = totalTime;
        }
        this.totalTime = totalTime;
        this.TOOL.player.maskEle.children().hide();
        this.TOOL.cancelPlay();
        this.TOOL.eve.emit("playByFrame", 0, this.TOOL.sprites[0].id);
        this.TOOL.eve.emit("play_" + this.TOOL.sprites[0].id, 0);
      }
    },
    calcFrame() {
      // 计算播放到哪个scenes的帧数
      if (this.timeNode.length) {
        let data = {};
        for (let i = 0; i < this.timeNode.length - 1; i++) {
          if (
            this.playTime >= this.timeNode[i] &&
            this.playTime <= this.timeNode[i + 1]
          ) {
            data.frame = Math.ceil((this.playTime - this.timeNode[i]) * 60);
            data.id = this.TOOL.sprites[i].id;
            return data;
          }
        }
      }
    },
    async recordStart() {
      this.showTip = false;
      if(this.totalTime - this.playTime < 0.2) {
        this.$message({
          showClose: true,
          message: '音频文件小于0.2s，无法加入!',
          type: 'warning'
        });
        return;
      }
      let hasReady = await this.recordAudio();
      if(!hasReady) return;
      this.countDown();
      await this.sleep(4000);
      if(this.breakAll) {
        this.recordFunc('stop');
        return;
      }
      this.recordFunc('start');
      this.recordStatus = 'ing';
      this.startTime = this.playTime;
      this.maxTime = this.totalTime - this.startTime;
      this.play(this.startTime, this.maxTime);
    },
    async recordAudio() {
      let tracks = await navigator.mediaDevices.getUserMedia({ audio: {
        sampleRate: 44100, // 采样率
        channelCount: 2,   // 声道
        volume: 1.0        // 音量
      }}).catch(err => {
        console.error(err)
        return null;
      })
      this.audioChunks = [];
      if(!tracks) return false;

      let recorder = new MediaRecorder(tracks);
      recorder.ondataavailable = event => {
        if(!this.breakAll) {
          this.audioChunks.push(event.data)
        }

        const aTracks = tracks.getTracks();
        aTracks.forEach(function(track) {
          track.stop();
        });
      }
      recorder.onstop = () => {
        if(this.breakAll) return;
        this.audio.src = URL.createObjectURL(new Blob(this.audioChunks));
        recorder = null;
        this.recorder = null;
      }

      this.recorder = recorder;

      return true;
    },
    recordFunc(name) {
      this.recorder && this.recorder[name]();
    },
    play(startTime = 0, endTime = 0) {
      let start = 0,
        progress = 0,
        step = null;

      step = timestamp => {
        if(!start) start = timestamp;
        progress = (timestamp - start) / 1000;
        if(this.recordStatus === 'ing') {
          this.recordTime = progress
        }
        if(progress < endTime) {
          this.playTime = progress + startTime;
          this.playEditor();

          this.animFrame = window.requestAnimationFrame(step);
        } else {
          if(this.recordStatus === 'ing') {
            this.recordFunc('stop');
            this.recordStatus = 'complete';
            this.soundTime = this.recordTime;
            this.endTime = this.startTime + this.soundTime;
          } else {
            this.playStatus = 'stop';
          }
          this.playTime = this.startTime;
          this.playEditor();

          window.cancelAnimationFrame(this.animFrame);
        }
      }
      this.animFrame = window.requestAnimationFrame(step);
    },
    playEditor() {
      let data = this.calcFrame();
      if(!data) return;
      this.TOOL.eve.emit("playByFrame", data.frame, data.id);
      this.TOOL.eve.emit("play_" + data.id, data.frame);
      this.$bus.emit("playSubtitleTime", {frame: Math.ceil(this.playTime * 60)});
    },
    cancelPlay() {
      if(this.recordStatus === 'ing') {
        this.recordFunc('stop');
        this.recordStatus = 'complete';
        this.soundTime = this.recordTime;
        this.endTime = this.startTime + this.soundTime;
      }
      window.cancelAnimationFrame(this.animFrame);
    },
    countDown() {
      // 录音倒计时
      this.recordStatus = 'ready';
      this.readyInfo = 3;
      let clock = setInterval(() => {
        this.readyInfo--;
        if(this.readyInfo <= 0) {
          this.readyInfo = 'GO';
          clearInterval(clock);
        }
      }, 1000)
    },
    sleep(time) {
      return new Promise(resolve => setTimeout(resolve, time))
    },
    playSound (type) {
      this.playStatus = type;
      if(type === 'start') {
        this.audio.currentTime = 0;
        this.audio.play();
        this.play(this.startTime, this.endTime - this.startTime);
      } else if(type === 'pause') {
        this.audio.pause();
        this.cancelPlay();
      } else if(type === 'stop') {
        this.audio.currentTime = 0;
        this.cancelPlay();
        this.audio.pause();
        this.playTime = this.startTime;
        this.playEditor();
      } else if(type === 'continue') {
        this.playStatus = 'start';
        this.audio.currentTime = this.playTime - this.startTime;
        this.audio.play();
        this.play(this.playTime, this.endTime - this.playTime);
      }
    },
    saveRecord() {
      // 保存录音
      this.playStatus === 'play' && this.playSound('stop');
      this.showSave = true;
      this.closeUpload = false;
    },
    reRecord() {
      // 重新录音
      this.playSound('stop');
      this.resetData();
    },
    resetData() {
      this.recordStatus = 'before';
      this.playTime = this.startTime;
      this.playStatus = 'stop';
      this.recordTime = 0;
      this.soundTime = 0;
      this.breakAll = false;
      this.audioChunks = [];
    },
    mousedown(dx) {
      this.mpos.x = dx;
      this.mpos.playTime = this.playTime;
      this.showTip = false;
    },
    mousemove(dx) {
      let dt = (dx - this.mpos.x) / this.secondWidth + this.mpos.playTime;
      this.playTime = dt < 0 ? 0 : dt > this.totalTime ? this.totalTime : dt;
      this.playEditor();
    },
    closeSave() {
      this.showSave = false;
    },
    saveUpload(data) {
      if(!this.audioChunks.length) {
        this.$message({
          showClose: true,
          message: '无录音数据！',
          type: 'error'
        });
        return;
      }
      let formData = new FormData();
      formData.append(data.name, this.audioChunks[0]);
      this.$http({
        url: '/api/upload/file/',
        method: 'post',
        data: formData,
      }).then(res => {
        if(res.data.code === 200) {
          let infoData = {
            title: data.name,
            url: res.data.data.filename,
            duration: this.recordTime,
            musicType: 1
          }
          this.$http.post('/api/user/music', infoData).then( resInfo => {
            let resData = resInfo.data.data;
            let audioInfo = {
              fileType: resData.fileType,
              id: resData.id,
              title: resData.title,
              url: resData.url,
              cut: [0, this.recordTime],
              timeSlot: [this.startTime, this.startTime + this.recordTime]
            }
            this.judgeAudio(audioInfo);
          }).catch( errInfo => {
            console.error(errInfo)
            this.$message({
              showClose: true,
              message: '文件上传错误，请重试！',
              type: 'error'
            });
            this.closeSave();
          })
        } else {
          this.$message({
            showClose: true,
            message: '文件上传错误，请重试！',
            type: 'error'
          });
          this.closeSave();
        }
      }).catch(() => {
        this.$message({
          showClose: true,
          message: '上传错误！请检查网络或文件格式',
          type: 'error'
        });
        this.closeSave();
      })
    },
    cancelUpload() {
      this.closeUpload = true;
      this.closeSave();
    },
    judgeAudio(data) {
      if(this.closeUpload) return;
      let audio = document.createElement('audio');
      audio.addEventListener('loadedmetadata', () => {
        this.closeSave();
        this.$bus.emit('record-sound-add', data);
        this.close()
      })
      audio.onerror = () => {
        let timeoutid = setTimeout(() => {
          this.judgeAudio(data);
          clearTimeout(timeoutid);
        }, 2000)
      }
      audio.src = this.$handleAssetsUrl(data.url);
    },
    close() {
      this.show = false;
      this.$store.commit("subtitle/toggle_isPreventDefault", true);
      this.breakAll = true;
      this.audioChunks = [];
      if(this.recordStatus === 'ing') {
        this.recordFunc('stop');
      }
      window.cancelAnimationFrame(this.animFrame);
    }
  },
  directives: {
    drag(el, binding, vnode) {
      let _this = vnode.context,
        mousemove = null,
        mouseup = null;

      mousemove = e => {
        e.preventDefault();

        _this.mousemove(e.pageX);
      };

      mouseup = e => {
        e.preventDefault();
        document.removeEventListener("mousemove", mousemove);
        document.removeEventListener("mouseup", mouseup);
      };

      el.onmousedown = e => {
        e.preventDefault();
        e.stopPropagation();
        if(_this.recordStatus !== 'before') return;

        document.addEventListener("mousemove", mousemove);
        document.addEventListener("mouseup", mouseup);

        _this.mousedown(e.pageX);
      };

      el.oncontextmenu = () => {
        return false;
      };
    }
  },
  filters: {
    secToMin(duration) {
      if (duration <= 0) return "00:00";
      if (!duration) return "--:--";
      let min = ~~(duration / 60);
      min = min.toString().padStart(2, '0');
      let sec = Math.floor(duration % 60);
      sec = sec.toString().padStart(2, '0');
      return min + ":" + sec;
    }
  }
}
</script>
<style lang="scss" scoped>
.record-dubbing {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 500;
}
.mask-content {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5;
  width: 100%;
  height: 100%;

  > div {
    position: absolute;
    background: rgba(0, 0, 0, 0.7);
  }
  .mask-top,
  .mask-bottom {
    width: 100%;
  }
}
.record-preview {
  position: absolute;
  height: 158px;
  background-color: #f0f0f8;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  z-index: 15;
}

.record-timeline {
  position: relative;
  top: -6px;
  left: 0;
  width: 100%;
  height: 6px;
  background-color: rgba(255, 255, 255, .6);

  &:before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 6px;
    height: 6px;
    background-color: #5778FB;
  }

  .record-timeline-box {
    position: relative;
    top: 0;
    left: 6px;
    width: calc(100% - 12px);
    height: 6px;
  }

  .rc-slider {
    position: relative;
    background-color: #5778FB;
    height: 6px;
    left: 0;
    top: 0;
    width: 69%;
  }

  .rc-slider-handle {
    position: absolute;
    top: -9px;
    left: calc(69% - 6px);
    height: 24px;
    width: 12px;
    border: 2px solid #5778FB;
    border-radius: 6px;
    background-color: #fff;
    cursor: grab;
  }
}
.record-button {
  width: 100%;
  display: flex;
  height: 100%;
  vertical-align: middle;
  justify-content: center;
}
.record-before, .record-ready, .ing-left {
  margin-top: 30px;
  text-align: center;
  color: #454463;

  div {
    display: inline-block;
    margin-bottom: 8px;
    width: 62px;
    height: 62px;
    border-radius: 50%;
    background: url('../../../../static/img/recordStart.png') no-repeat center;
    background-color: #454463;
    cursor: pointer;
  }
}
.record-ready div {
  font-size: 24px;
  line-height: 62px;
  color: #fff;
  font-weight: bolder;
  background: #EA3E3E;
}

.record-ing, .record-complete {
  display: flex;
  justify-content: center;

  >p {
    margin: 30px 50px 0 50px;
    height: 59%;
    border-left: 1px solid #ddd;
  }
}
.ing-left div {
  background: url('../../../../static/img/recording.gif') no-repeat center;
  background-color: #EA3E3E;
}

.ing-right, .complete-right {
  display: flex;
  margin-top: 30px;
  flex-direction: column;
}
.ing-time {
  display: flex;
  align-items: baseline;
  margin-bottom: 20px;

  span:first-child {
    font-size: 23px;
    margin-right: 5px;
  }
  span:last-child {
    color: #888;
  }
}
.ing-button {
  width: 100px;
  height: 38px;
}

.complete-left {
  display: flex;
  margin-top: 30px;
  justify-content: flex-end;
  width: 235px;

  >div {
    text-align: center;
    color: #454463;
    margin-left: 55px;

    div {
      display: inline-block;
      margin-bottom: 8px;
      width: 62px;
      height: 62px;
      // border-radius: 50%;
      background-size: 36%;
      background-color: #454463;
      cursor: pointer;
    }
  }

  .start div{
    background: url('../../../../static/svg/play.svg');
    &:hover {
      background: url('../../../../static/svg/play-active.svg');
    }
  }
  .pause div{
    background: url('../../../../static/svg/pause.svg');
    &:hover {
      background: url('../../../../static/svg/pause-active.svg');
    }
  }
  .stop div{
      background: url('../../../../static/svg/stop.svg');
      &:hover {
        background: url('../../../../static/svg/stop-active.svg');
    }
  }
}
.complete-right {
  text-align: left;

  span {
    margin-bottom: 25px;
    font-size: 22px;
  }

  button {
    width: 100px;
    height: 34px;
    padding: 5px;
  }

  button:last-child{
    border-color: #454463;
    background-color: #f0f0f8;
  }
}
.complete-button {
  button:last-child:hover {
    border-color: #5778FB;
  }
}

.time-show-box {
  position: absolute;
  top: 5px;
  left: 6px;
}

.record-drag-tip {
  position: absolute;
  width: 199px;
  height: 46px;
  background: rgba(0, 0, 0, .5);
  border-radius: 4px;
  padding: 6px 20px;
  line-height: 18px;
  font-size: 12px;
  color: #fff;
  text-align: left;
}

.save-box {
  position: absolute;
  display: flex;
  align-items: center;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 25;
}
.record-close-button {
  position: absolute;
  width: 40px;
  height: 40px;
  z-index: 15;
  cursor: pointer;

  i {
    position: relative;
    left: 0px;
    top: 7px;
    width: 5px;
    height: 27px;
    border-radius: 3px;
    background: #fff;
    transform: rotate(45deg);
    display: inline-block;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 5px;
      height: 27px;
      border-radius: 3px;
      background: #fff;
      transform: rotate(270deg);
    }
  }
}
.record-error {
  position: absolute;
  display: flex;
  align-items: center;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 25;
}
.record-error-box {
  position: relative;
  margin: auto;
  width: 525px;
  height: 235px;
  background: #fff;
  border-radius: 3px;
  overflow: hidden;

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px 0 15px;
    height: 28px;
    background-color: #d8dee9;
    color: #474261;
  }
  div.close-button {
    position: absolute;
    right: 10px;
    top: 5px;
    width: 16px;
    cursor: pointer;
  }
  i {
    position:relative;
    left: 7px;
    top: 2px;
    width: 2px;
    height: 15px;
    border-radius: 3px;
    background: #737596;
    transform: rotate(45deg);
    display: inline-block;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 2px;
      height: 15px;
      border-radius: 3px;
      background: #737596;
      transform: rotate(270deg);
    }
  }
  .content {
    color: #666;
    font-size: 13px;
    margin: 25px;
    div {
      line-height: 2.5;
    }
  }
  .button-content {
    text-align: center;

    button {
      height: 36px;
      padding: 10px 34px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/record/record.vue